export interface StudentDataReportFilterValues {
  schoolId: string
  classId: string
  dateFrom: string
  dateTo: string
  kind: string
  incomeKind: string
  category: string
  classification: string
  emotion: string
}

export const EMPTY_STUDENT_DATA_REPORT_FILTERS: StudentDataReportFilterValues = {
  schoolId: '__all__',
  classId: '__all__',
  dateFrom: '',
  dateTo: '',
  kind: '__all__',
  incomeKind: '__all__',
  category: '__all__',
  classification: '__all__',
  emotion: '__all__',
}
